import { reverse } from 'ramda';

import { IOffer } from '../../../../types/offerData';
import { isBusinessSale } from '../../../../utils/commercial';
import { FieldType, IConfigOptions } from '../config';
import { getAmenitiesLabel } from './getAmenitiesLabel';
import { getCommercialMultiAdsAreaConfig } from './getCommercialMultiAdsAreaConfig';
import { getCommercialMultiAdsFloorConfig } from './getCommercialMultiAdsFloorConfig';
import { getCommercialMultiAdsParkingsConfig } from './getCommercialMultiAdsParkingsConfig';
import { getInfoValue } from './getInfoValue';
import { getSpecialtiesLabel } from './getSpecialtiesLabel';

export function getFormattedConfig(config: FieldType, offer: IOffer, options?: IConfigOptions) {
  const isCommercialMultiAds = options?.isCommercialMultiAds;
  const bscParkings = options?.bscParkings;
  const { coworking, specialty, building } = offer;

  if (config.type === 'coworkingAmenitiesType') {
    if (!coworking?.includedAmenities?.length) {
      return null;
    }

    return reverse(getAmenitiesLabel(coworking.includedAmenities));
  }

  if (config.type === 'specialties') {
    const isNewBusinessSaleCategory = isBusinessSale(offer);

    const specialtiesCount = specialty?.specialties?.length ?? 0;
    const isSpecialtyBlockVisible = specialtiesCount === 1 || specialtiesCount >= 4;

    if (!specialty?.specialties || !isSpecialtyBlockVisible || !isNewBusinessSaleCategory) {
      return null;
    }

    const { specialties } = specialty;

    return reverse(getSpecialtiesLabel(specialties));
  }

  if (isCommercialMultiAds) {
    if (config.type === 'floorNumber') {
      return getCommercialMultiAdsFloorConfig(offer);
    }

    if (config.type === 'commercialArea') {
      return getCommercialMultiAdsAreaConfig(offer);
    }

    if (config.type === 'parkingPlacesCount') {
      return getCommercialMultiAdsParkingsConfig(building, bscParkings);
    }
  }

  return [config.title, getInfoValue(config, offer)];
}
